import { CSSProperties } from 'react';
import styled from 'styled-components';
import { border1, lightGrayBackground } from '../../../../utils/style/colors';

type ChangeImplicitButtonProps = {
  isImplicit: boolean;
  disabled: boolean;
};

type ItemProps = {
  hasChevron?: boolean;
};

export const Item = styled('li')<ItemProps>`
  align-items: center;
  flex-wrap: wrap;
  margin: 0 ${({ hasChevron }) => (hasChevron ? '0.0em' : '1em')} !important;
  padding: 1em ${({ hasChevron }) => (hasChevron ? '1.0em' : '1em')} 1em 1em;
  border-bottom: ${border1};
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: space-between;
`;

export const RightSideItems = styled('div')`
  align-items: center;
  display: flex;
`;
export const LeftSideItems = styled('div')`
  flex-wrap: wrap;
  align-items: center;
  display: flex;
`;

export const Actions = styled('div')`
  display: flex;
  & > span {
    padding: 0 0.5rem;
  }
`;

export const ChangeImplicitButton = styled('div')<ChangeImplicitButtonProps>`
  align-items: center;
  background-color: rgb(232, 244, 253, 0.8);
  border: ${border1};
  border-radius: 10px;
  color: rgb(13, 60, 97);
  cursor: pointer;
  display: flex;
  font-size: 0.8rem;
  font-weight: 400;
  height: 2rem;
  justify-content: space-between;
  margin-left: 1rem;
  padding: 0.5rem;
  position: relative;
  transition: 0.3s all ease;
  width: 10rem;
  :hover {
    border: 1px solid rgb(13, 60, 97, 0.2);
  }
  & > span:first-child {
    align-items: center;
    display: inline-flex;
    height: 100%;
    justify-content: flex-start;
    width: 1.5rem;
  }
  ${({ isImplicit }) =>
    isImplicit &&
    `
      background-color: rgb(237, 247, 237, 0.8);
      border: ${border1};
      color: rgb(30, 70, 32);
      :hover {
        border: ${border1};
      }
  `}
  ${({ disabled }) =>
    disabled &&
    `
      background-color: ${lightGrayBackground};
      border: ${border1};
      color: rgb(30, 70, 32);
      :hover {
        border: ${border1};
      }
      cursor: unset;
  `}
`;

export const projectLoadingStyles: CSSProperties = {
  position: 'relative',
  width: '1.2rem',
  height: '1.2rem',
};
